<template>

  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class="ue-statisticsBox" >
        <li>{{$t("UE.bs_online_count")}}<span class="ue-statisticsBlue">{{onlineEqCnt}}</span></li>
        <li>{{$t("UE.ue_online_count")}}<span class="ue-statisticsGreen">{{onlineUeCnt}}</span></li>
      </div>
      <UeGpsMap ref="ueMap"></UeGpsMap>
        <div class="h-toolbarBg">
          <ejs-toolbar>
            <div>
              <div><button class="e-btn e-tbar-btn icon hero-icon hero-icon-topo-mc_cf" :title='$t("UE.select_ue")' @click='showQryUePage()'/></div>
            </div>
          </ejs-toolbar>
        </div>
      <CustomDialog ref='chartPage' v-bind:element='chartPage.element' v-bind:styles='chartPage.styles' >
        <UeSubcriberChart slot="dialog-content" ref="ueChart"></UeSubcriberChart>
      </CustomDialog>
        <CustomDialog ref='qryUePage' v-bind:element='qryUePage.element' v-bind:styles='qryUePage.styles' >
          <QueryUeList slot="dialog-content" ref='qryUeList' @childProps="getChildProps"></QueryUeList>
        </CustomDialog>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import UeGpsMap from '../../components/ueConfig/UeGpsMap';
import UeSubcriberChart from "../../components/ueConfig/UeSubcriberChart";
import QueryUeList from "../../components/ueConfig/QueryUeList";
import CustomDialog from "../../components/common/CustomDialog";
import {EventBus} from "../../plugins/eventBus";
export default {
  name: 'UeShowMap',
  components: {
    CustomDialog,
    UeSubcriberChart,
    BasicLayout,
    UeGpsMap,
    QueryUeList
  },
  data() {
    return {
      onlineEqCnt:0,
      onlineUeCnt:0,
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('UE.ueManager')}/${this.$t('UE.ueShowMap')}`},
      childProps:{},
      onlineUeList:[],
      selectedImsi:[],
      bsTimer: '',
      ueTimer: '',
      ueState:[{text:`${this.$t("UE.ue_state_off")}`,value:2},{text:`${this.$t("UE.ue_state_up")}`,value:0},{text:`${this.$t("UE.ue_state_idle")}`,value:1}],
      qryUePage: {
        element: {
          refName: 'qryUeList',
          isClose: true,
          buttonGroup: [
            { click: this.closeQryUePage, buttonModel: { content: this.$t('UE.ueCancell') } },
            { click: this.confirmQryUe, buttonModel: { content: this.$t('UE.ueConfirm') , cssClass:"primary-btn"} }
          ],
          title: this.$t('UE.select_ue')
        },
        styles: {
          width: '810px',
          height: 'auto',
          visible: false,
          model: true
        }
      },
      chartPage: {
        element: {
          refName: 'ueChart',
          isClose: true,
          buttonGroup: [
            { click: this.closeUeChart, buttonModel: { content: this.$t('UE.ueCancell') } },
          ],
          title: this.$t('UE.ue_chart')
        },
        styles: {
          width: '90%',
          height: '80%',
          visible: false,
          model: true
        }
      },
    };
  },
  beforeDestroy() {
    clearInterval(this.bsTimer);
    clearInterval(this.ueTimer);
  },
  methods: {
    showQryUePage(){
      this.$refs.qryUeList.setSelectedUe(this.selectedImsi);
      this.$refs.qryUeList.setUeList(this.onlineUeList);
      this.$refs.qryUePage.show();
    },
    confirmQryUe(){
      if(this.childProps.imsi.length == 0){
        EventBus.$emit('toast', {type: 'warning', content: this.$t('UE.select_ue_data')});
        return false;
      }
      if(this.childProps.imsi.length > 5){
        EventBus.$emit('toast', {type: 'warning', content: this.$t('UE.ue_select_limit')});
        return false;
      }
      this.selectedImsi = this.childProps.imsi;
      const param = {imsi:this.selectedImsi.join(","), interval:30};
      this.$refs.qryUePage.clear();
      this.$refs.qryUePage.close();
      this.$refs.ueChart.queryData(param);
      this.$refs.chartPage.show();
    },
    getChildProps(data) {
      this.childProps = data;
    },
    closeQryUePage() {
      this.$refs.qryUePage.clear();
      this.$refs.qryUePage.close();
    },
    closeUeChart() {
      this.$refs.ueChart.clearTimer();
      this.$refs.chartPage.close();
    },
    /**
     * 查询所有基站信息
     */
    qryAllEquipments() {
      const $this = this;
      this.$axios.get('/lte/ems/eam/ue/equipments').then((response) => {
        if(response.status === 200 && response.data != null){
          this.onlineEqCnt = response.data.eqUpCount;
          const equipmentList = response.data.dataList;
          if (equipmentList.length === 0) {return};
          const eqInfo = [];
          equipmentList.forEach((item) => {
            // 区域对象:包括
            const areaItem = {
              longitude: item.equipment.longitude,
              latitude: item.equipment.latitude,
              state: item.state,
              eqAlias: item.equipment.name,
              eqId: item.equipment.id
            };
            eqInfo.push(areaItem);
          });
          $this.$refs.ueMap.markEquipments(eqInfo);
        }
      });
    },

    /**
     * 查询所有在线的UE信息
     */
    qryAllOnlineUe() {
      const ueInfo = [];
      const online = [];
      const $this = this;
      this.$axios.get('/lte/ems/eam/ue/queryImsiList').then((response) => {
        if(response.status === 200){
          const resultVal = response.data.resultVal;
          resultVal.forEach((item) => {
            let stateStr = "";
            $this.ueState.forEach(i =>{
              if(i.value == item.stateAndData.state){
                stateStr = i.text;
              }
            });
            const areaItem = { // 区域对象:包括
              longitude: item.longitude,
              latitude: item.latitude,
              state: item.stateAndData.state,
              stateStr: stateStr,
              ueAlias: item.stateAndData.ueAlias,
              imsi: item.stateAndData.imsi,
              eqAlias: item.stateAndData.stationAlias,
              ip4: item.stateAndData.ip4
            };
            ueInfo.push(areaItem);
            if(item.stateAndData.state == 0){
              online.push(areaItem);
            }
          });
          $this.onlineUeList = online;
          $this.onlineUeCnt = online.length;
          $this.$refs.ueMap.markOnlineUe(ueInfo);
        }
      });
    },
  },
  mounted() {
    this.qryAllEquipments();
    this.qryAllOnlineUe();
    this.bsTimer = setInterval(this.qryAllEquipments, 60000);
    this.ueTimer = setInterval(this.qryAllOnlineUe, 60000);
  }
};
</script>

<style scoped>
  .e-toolbar{
    float:right!important;
  }
</style>
